import * as API from '@/services/API';

export default {
  async getStripeSession({ commit }) {
    await API.apiClient
      .get('/stripe/subscribe')
      .then((response) => {
        commit('SET_STRIPE_SESSION', response.data);
        return response.data;
      })
      .catch((error) => {
        commit('SET_ERROR', error, { root: true });
      });
  },
  getCheckoutLink({ commit }, item) {
    return API.apiClient
      .get('/stripe/checkout?price=' + item)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        commit('SET_ERROR', error, { root: true });
      });
  },
  async getSubscription({ commit }) {
    return await API.apiClient
      .get('/stripe/subscription')
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        console.log(error);
        //commit('SET_ERROR', error, { root: true });
      });
  },
  async getProducts({ commit }) {
    return await API.apiClient
      .get('/stripe/products')
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        commit('SET_ERROR', error, { root: true });
        return [];
      });
  },
};
